import { Component, inject, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CronEditorModule, CronOptions } from 'ngx-cron-editor';
import { MaterialModule } from '../../../core/shared/material.module';

@Component({
  selector: 'app-cron-expression-input',
  standalone: true,
  imports: [MaterialModule,CronEditorModule],
  templateUrl: './cron-expression-input.component.html',
  styleUrl: './cron-expression-input.component.scss'
})
export class CronExpressionInputComponent {
@Input()
    data: { title?: string, id?:string} = {};
activeModal = inject(NgbActiveModal);
cronForm: any;
  public cronOptions: CronOptions = {
    defaultTime: "00:00:00",

    hideMinutesTab: false,
    hideHourlyTab: false,
    hideDailyTab: false,
    hideWeeklyTab: false,
    hideMonthlyTab: false,
    hideYearlyTab: false,
    hideAdvancedTab: true,
    hideSpecificWeekDayTab: false,
    hideSpecificMonthWeekTab : false,

    use24HourTime: true,
    hideSeconds: false,

    cronFlavor: "quartz" //standard or quartz
 };
ngOnInit(): void {
  this.cronForm = new FormControl('0 4 * * * * *');
}
  closePopup(){
    this.activeModal.dismiss('Cross click');
  }
  saveCron(){
    this.activeModal.close(this.cronForm.value);
  }
}
